module.exports = __webpack_public_path__ + "img/valentin-ionita.de5de900.jpg";